<template>
  <div class="elite-tabs-wrapper-content">
    <h3>{{ $t("IMPORTS.RESULTS_ON_X_LINES", { linesCount: totalCount }) }}</h3>
    <el-collapse>
      <el-collapse-item name="1" class="">
        <template #title>
          <h3>
            {{ $t("IMPORTS.SUCCESSES") }}
            <badge type="success">{{ successes.length }}</badge>
          </h3>
        </template>
        <div>
          <el-table :data="successesPagedRows">
            <el-table-column
              prop="line"
              :label="$t('IMPORTS.LINE')"
              width="150px"
            >
              <template v-slot="{ row }">
                {{ $t("IMPORTS.X_ROW", { line: row.line }) }}
              </template>
            </el-table-column>
            <el-table-column prop="data" :label="$t('IMPORTS.DATA')">
              <template v-slot="{ row }">
                {{ row.data }}
              </template>
            </el-table-column>
            <el-table-column
              prop="id"
              :label="$t('IMPORTS.MODEL_ID')"
              width="100px"
            >
              <template v-slot="{ row }">
                {{ row.id }}
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            layout="prev, pager, next"
            :total="successes.length"
            @current-change="
              (val) => {
                successesPage = val;
              }
            "
          ></el-pagination>
        </div>
      </el-collapse-item>
      <el-collapse-item name="2" class="">
        <template #title>
          <h3>
            {{ $t("IMPORTS.FAILURES") }}
            <badge type="danger">{{ failures.length }}</badge>
          </h3>
        </template>
        <div>
          <el-table :data="failuresPagedRows">
            <el-table-column
              prop="line"
              :label="$t('IMPORTS.LINE')"
              width="150px"
            >
              <template v-slot="{ row }">
                {{ $t("IMPORTS.X_ROW", { line: row.line }) }}
              </template>
            </el-table-column>
            <el-table-column prop="data" :label="$t('IMPORTS.DATA')">
              <template v-slot="{ row }">
                {{ row.data }}
              </template>
            </el-table-column>
            <el-table-column prop="error" :label="$t('IMPORTS.ERROR')">
              <template v-slot="{ row }">
                {{ row.error }}
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            layout="prev, pager, next"
            :total="failures.length"
            @current-change="
              (val) => {
                failuresPage = val;
              }
            "
          ></el-pagination>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  Pagination,
  Collapse,
  CollapseItem,
} from "element-ui";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Pagination.name]: Pagination,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
  },

  mixins: [],

  props: ["importResults"],

  data() {
    return {
      failuresPage: 1,
      successesPage: 1,
      pageSize: 10,
    };
  },

  computed: {
    successes() {
      return Object.values(this.importResults).filter((item) => item.success);
    },
    failures() {
      return Object.values(this.importResults).filter((item) => !item.success);
    },
    totalCount() {
      return Object.values(this.importResults).length;
    },
    successesPagedRows() {
      return this.successes.slice(
        this.pageSize * this.successesPage - this.pageSize,
        this.pageSize * this.successesPage
      );
    },
    failuresPagedRows() {
      return this.failures.slice(
        this.pageSize * this.failuresPage - this.pageSize,
        this.pageSize * this.failuresPage
      );
    },
  },

  methods: {},

  mounted() {},

  watch: {},
};
</script>
